import { SpinnerService } from '../services/spinner.service';

export class ShowOrHideSpinner {

    constructor() {
    }

    public showSpinner(spinnerService: SpinnerService) {
        spinnerService.inProgress = true;
    }

    public hideSpinner(spinnerService: SpinnerService) {
        spinnerService.inProgress = false;
    }

    public isSpinnerNotInProgress(spinnerService: SpinnerService) {
        return !spinnerService.inProgress;
    }
}
